import { z } from 'zod';

const MAX_FILE_SIZE_MB = 25;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
const ACCEPTED_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

export const certificateUploadSchema = z.object({
  accreditationType: z
    .string({ required_error: 'Selecteer een accreditatietype' })
    .min(1, 'Selecteer een accreditatietype'),

  certificate: z
    .string({ required_error: 'Selecteer een certificaat' })
    .min(1, 'Selecteer een certificaat'),

  certificateFile: z
    .array(z.instanceof(File))
    .min(1, 'Certificaatbestand is verplicht')
    .refine(
      (files) => files.every((file) => file.size <= MAX_FILE_SIZE),
      `Maximale bestandsgrootte is ${MAX_FILE_SIZE_MB} MB`
    )
    .refine(
      (files) => files.every((file) => ACCEPTED_MIME_TYPES.includes(file.type)),
      'Alleen PDF-, JPEG- en PNG-bestanden worden ondersteund'
    ),

  termsAndConditionsAccepted: z.boolean().refine((val) => val === true, {
    message: 'U moet akkoord gaan met de algemene voorwaarden om door te gaan.',
  }),

  email: z.string().email('Ongeldig e-mailadres'),
});

export type CertificateUploadFormValues = z.infer<typeof certificateUploadSchema>;
